module.exports = __webpack_public_path__ + "img/logo_skb_list.dd32f94e.png";